'use client';
import { useCallback } from 'react';
import { useMe, useMyTerminalSettings } from '../../lib/queries';
import { TERMINAL_DEFAULTS } from '../../components/terminal/palettes';
import { useToast } from '../../components/ui/Toast';
import { useTranslation } from '../../lib/i18n';
import { appendPromptHistory, readPromptHistory } from './promptHistory';

/** Identity is the effective account, including impersonation; no shared-machine anonymous bucket. */
export function usePromptHistory() {
  const me = useMe();
  const settings = useMyTerminalSettings();
  const userId = me.data?.user?.id ?? null;
  const depth = settings.data?.promptHistoryDepth ?? TERMINAL_DEFAULTS.promptHistoryDepth;
  const { toast } = useToast();
  const { t } = useTranslation();
  const read = useCallback(() => {
    if (userId === null) return [];
    try { return readPromptHistory(localStorage, userId, depth); }
    catch { toast(t.brainChat.promptHistoryError, 'error'); return []; }
  }, [userId, depth, toast, t.brainChat.promptHistoryError]);
  const record = useCallback((text: string) => {
    if (userId === null) return;
    try { appendPromptHistory(localStorage, userId, text, depth); }
    catch { toast(t.brainChat.promptHistoryError, 'error'); }
  }, [userId, depth, toast, t.brainChat.promptHistoryError]);
  return { userId, read, record };
}
